module.exports = __webpack_public_path__ + "img/master.a670a4c3.svg";